import request from '@/services/interceptor.js'


export const get_oreClienti = (par, data) => {
    return request({
        url: '/clienti/ore/' + par,
        method: 'post',
        data: data,
        loadingBar: true
    })
};

// Dashboard Analytics
export const get_kpi_ore = (data) => {
    return request({
        url: '/clienti/kpi',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

// Andamento
export const get_dati_mensili_ore = (data) => {
    return request({
        url: '/clienti/dati-mensili',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const get_confronto_anni_ore = (data) => {
    return request({
        url: '/clienti/confronto-anni',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const get_stagionalita_ore = (data) => {
    return request({
        url: '/clienti/stagionalita',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const get_previsione_ore = (data) => {
    return request({
        url: '/clienti/previsione',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

// Composizione
export const get_top_clienti_ore = (data) => {
    return request({
        url: '/clienti/top-clienti',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const get_heatmap_clienti_ore = (data) => {
    return request({
        url: '/clienti/heatmap-clienti',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

// Confronti
export const get_confronto_multi_anno_ore = (data) => {
    return request({
        url: '/clienti/confronto-multi-anno',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const get_variazione_yoy_ore = (data) => {
    return request({
        url: '/clienti/variazione-yoy',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const get_analisi_trimestri_ore = (data) => {
    return request({
        url: '/clienti/analisi-trimestri',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const get_statistiche_periodo_ore = (data) => {
    return request({
        url: '/clienti/statistiche-periodo',
        method: 'post',
        data: data,
        loadingBar: true
    })
}